import type { RateType } from '@type/billing'
import type { Plan } from './Account'
import type { Feature } from '@src/types/features'

export interface CheckoutStripeRequest {
  product_price: string
}
export interface UpgradeStripeRequest {
  price: string
}

export interface SetupIntentResponse {
  client_secret: string
  publishable_key: string
}

export interface CompleteSetupIntentRequest {
  payment_method_id: string
}

export interface BillingPortalResponse {
  url: string
}

export interface CompleteSetupIntentResponse {
  has_payment_method: boolean
  // true = a free trial was started; false = the card was charged immediately.
  is_trial: boolean
  // Set when an immediate charge needs 3D-Secure; confirm it client-side.
  requires_action: boolean
  payment_intent_client_secret: string | null
}

export const enum Status {
  trialing = 'trialing',
  active = 'active',
  cancelled = 'cancelled',
  inactive = 'inactive',
  // Renewal charge failed; Stripe is retrying. Access continues during recovery.
  pastDue = 'past_due',
}

export const enum Platform {
  manual = 'manual',
  stripe = 'stripe',
}

export interface Subscription {
  next_payment_at: string
  ends_at: string
  status: Status
  interval: RateType
  amount: number
  plan: Plan
  platform: Platform
  trial_end: string
  is_trial: boolean
  plan_features: Record<Feature, boolean>
  has_payment_method: boolean
  // false once the team has consumed its one free trial (getting Starter is then
  // a direct purchase, not another trial).
  trial_eligible: boolean
}

export interface UnsubscribeQuestion {
  id: number
  title: string
  type: string
  answers: { answer: string; action_id: number }[]
}

export interface UnsubscribeQuestionAnswer {
  question: number
  answer: {
    unsubscribe: boolean
    reason: string
    message: string
  }
}
